import { Routes } from "@angular/router";
import { CanDeactivateGuard } from "../../core/guards/can-deactivate/can-deactivate.guard";
import { DeliveryStatusListComponent } from "./delivery-status-list/delivery-status-list.component";
import { ProductionWorkflowListingComponent } from "./production-workflow-listing/production-workflow-listing.component";
import { ProductionWorkflowSummaryComponent } from "./production-workflow-summary/production-workflow-summary.component";
import { ReassignWorkflowApprovalComponent } from "./reassign-workflow-approval/reassign-workflow-approval.component";
import { ProductionWorkflowArchivedListingComponent } from "./production-workflow-archived-listing/production-workflow-archived-listing.component";

export const projectWorkflowRoutes: Routes = [
  {
    path: "",
    component: ProductionWorkflowListingComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: "archive",
    component: ProductionWorkflowArchivedListingComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: "workflow-summary/:id",
    component: ProductionWorkflowSummaryComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: "workflow-summary/:id/:salesOrderId",
    component: ProductionWorkflowSummaryComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: "workflow-approval/:workflowId/:newOwner",
    component: ReassignWorkflowApprovalComponent,
  },
  {
    path: "delivery-status-and-exception",
    component: DeliveryStatusListComponent,
  },

  {
    path: "workflow-summary/:id/:salesOrderId/:showCloseIcon",
    component: ProductionWorkflowSummaryComponent,
    canDeactivate: [CanDeactivateGuard],
  },
];
